import { LanguageCode } from "./LanguageCode";
import { ProductCategoryTypes } from "./PolarProductList";
import { PolarProductTypes } from "./PolarProductTypes";

export enum PresetGroups {
    Poluv = "Poluv",
    Anipuri = "anipuri",
    Moshi = "moshi"
}

export enum PresetTypes {
    Custom = "Custom",
    IpSpecialPola = "IpSpecialPola",
    IpSpecialColorNames = "IpSpecialColorNames",
    PromotionColorNames = "PromotionColorNames",
    PromotionCardCovers = "PromotionCardCovers",
    PromotionPhotoCard = "PromotionPhotoCard",
    Stamp = "Stamp",
    CheerUpGroupSlogan = "CheerUpGroupSlogan",
    CheerUpMemberSlogan = "CheerUpMemberSlogan",
    IpSpecialCheerUp = "IpSpecialCheerUp",
    CheerUpCustomSlogan = "CheerUpCustomSlogan",
    Colornames = "Colornames",
    LargeNames = "LargeNames",
    NemoNames = "NemoNames"
}

export interface PresetConfig {
    groups: PresetGroups[];
    type: PresetTypes;
    dedicatedProducts: PolarProductTypes[];
    isPackageConfigurable: boolean;
    isProbabilityConfigurable: boolean;
    isPriorityConfigurable: boolean;
    isDedicatedProductsConfigurable: boolean;
    isThumbnailConfigurable?: boolean;
    configurableLanguages: LanguageCode[];
}

export const presetConfigs: PresetConfig[] = [
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.Custom,
        dedicatedProducts: [],
        isPackageConfigurable: true,
        isProbabilityConfigurable: true,
        isPriorityConfigurable: true,
        isDedicatedProductsConfigurable: true,
        configurableLanguages: Object.values(LanguageCode)
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.IpSpecialPola,
        dedicatedProducts: [PolarProductTypes.IpSpecial],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Anipuri],
        type: PresetTypes.IpSpecialPola,
        dedicatedProducts: [PolarProductTypes.IpSpecial],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [LanguageCode.koKR, LanguageCode.zhCN, LanguageCode.zhHK]
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.IpSpecialColorNames,
        dedicatedProducts: [PolarProductTypes.IpSecialColornames],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.PromotionColorNames,
        dedicatedProducts: [PolarProductTypes.ColornamesColorful],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.PromotionCardCovers,
        dedicatedProducts: [PolarProductTypes.CardCoverStickerDieCut],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.PromotionPhotoCard,
        dedicatedProducts: [PolarProductTypes.PhotoCard],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Anipuri],
        type: PresetTypes.PromotionPhotoCard,
        dedicatedProducts: [PolarProductTypes.PhotoCard],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.zhHK, LanguageCode.jaJP
        ]
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.Stamp,
        dedicatedProducts: [
            PolarProductTypes.Classic, PolarProductTypes.ClassicNew, PolarProductTypes.BoldFrame,
            PolarProductTypes.CardCoverSticker, PolarProductTypes.FullFrame, PolarProductTypes.FullFrame6x8,
            PolarProductTypes.MultiFrame6x8, PolarProductTypes.SloganSticker2Cut, PolarProductTypes.SloganSticker3Cut,
            PolarProductTypes.IglooPhotoBooth, PolarProductTypes.MultiFrame6x8, PolarProductTypes.MyRoutineCalendar,
            PolarProductTypes.Mini, PolarProductTypes.Minime, PolarProductTypes.NarrowFrame,
            PolarProductTypes.PhotoCard, PolarProductTypes.PhotoCardEvolis, PolarProductTypes.PhotoCardEvolisHighTeen,
            PolarProductTypes.PhotoCardEvolisId, PolarProductTypes.PhotoCardEvolisIgloo, PolarProductTypes.TemplateFrame,
            PolarProductTypes.TimeTable, PolarProductTypes.VerticalFrame, PolarProductTypes.WaterGlitter,
            PolarProductTypes.DaisoGiftCard5K, PolarProductTypes.DaisoGiftCard10K, PolarProductTypes.DaisoGiftCard30K,
            PolarProductTypes.DaisoGiftCard50K,
        ],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.CheerUpGroupSlogan,
        dedicatedProducts: [PolarProductTypes.CheerUpGroupSlogan],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: true,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: Object.values(LanguageCode)
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.CheerUpMemberSlogan,
        dedicatedProducts: [PolarProductTypes.CheerUpMemberSlogan],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: true,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: Object.values(LanguageCode)
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.IpSpecialCheerUp,
        dedicatedProducts: [PolarProductTypes.IpSpecialCheerUp],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: true,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: Object.values(LanguageCode)
    },
    {
        groups: [PresetGroups.Poluv],
        type: PresetTypes.CheerUpCustomSlogan,
        dedicatedProducts: [PolarProductTypes.CheerUpCustomSlogan],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: true,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: Object.values(LanguageCode)
    },
    {
        groups: [PresetGroups.Moshi],
        type: PresetTypes.IpSpecialColorNames,
        dedicatedProducts: [PolarProductTypes.IpSecialColornames],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Moshi],
        type: PresetTypes.Colornames,
        dedicatedProducts: [PolarProductTypes.ColornamesColorful],
        isPackageConfigurable: false,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        isThumbnailConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Moshi],
        type: PresetTypes.LargeNames,
        dedicatedProducts: [PolarProductTypes.GraphicNamesticker],
        isPackageConfigurable: true,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        isThumbnailConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    },
    {
        groups: [PresetGroups.Moshi],
        type: PresetTypes.NemoNames,
        dedicatedProducts: [PolarProductTypes.GraphicNamesticker12cut],
        isPackageConfigurable: true,
        isProbabilityConfigurable: false,
        isPriorityConfigurable: false,
        isDedicatedProductsConfigurable: false,
        isThumbnailConfigurable: false,
        configurableLanguages: [
            LanguageCode.koKR, LanguageCode.enUS, LanguageCode.zhCN,
            LanguageCode.jaJP, LanguageCode.thTH
        ]
    }
]
